import { NextApiRequest } from 'next';

export const FEATURE_FLAG_KLARNA = process.env.NEXT_PUBLIC_KLARNA_FF === 'true';
export const FEATURE_FLAG_KLARNA_TOP_RIBBON =
  process.env.NEXT_PUBLIC_KLARNA__TOP_RIBBON_FF === 'true';

export const FEATURE_FLAG_DISABLE_SPU =
  process.env.NEXT_PUBLIC_DISABLE_SPU_FF === 'true';

export const FEATURE_FLAG_NO_PICKUP_TIMES = false;
export const FEATURE_FLAG_NEXT_DAY = true;

export const FEATURE_FLAG_PRODUCT_TAGS =
  process.env.NEXT_PUBLIC_FF_PRODUCT_TAGS === 'true';

export const FEATURE_FLAG_PRODUCT_TAGS_FROM_METAFIELD =
  process.env.NEXT_PUBLIC_FF_PRODUCT_TAGS_FROM_METAFIELD === 'true';

export const FEATURE_FLAG_GUEST_CHECKOUT =
  process.env.NEXT_PUBLIC_GUEST_CHECKOUT_FF === 'true'; // TODO: Opened a ticket with BC Support to see if the checkout options are available through the API

export const FEATURE_FLAG_LOYALTY =
  process.env.NEXT_PUBLIC_LOYALTY_FF === 'true';

export const loyaltyFFCookieName = 'loyalty-ff';
export const getLoyaltyFeatureFlag = (req?: NextApiRequest) => {
  return req?.cookies[loyaltyFFCookieName] === 'true' || FEATURE_FLAG_LOYALTY;
};

export const FEATURE_FLAG_NEW_YEARS_PROMOTION =
  process.env.NEXT_PUBLIC_ENABLE_NEW_YEARS_PROMOTION === 'true';

export const FEATURE_FLAG_PTT_VIDEO =
  process.env.NEXT_PUBLIC_PTT_VIDEO_FF === 'true';

export const FEATURE_FLAG_SHOP_CANADIAN =
  process.env.NEXT_PUBLIC_ENABLE_SHOP_CANADIAN === 'true';

export const FEATURE_ALGONOMY_ID_PATH =
  process.env.NEXT_PUBLIC_ENABLE_ALGONOMY_PATH_IDS === 'true';

export const algonomyPathFFCookieName = 'algonomy-path-ff';
export const getAlgonomyPathFeatureFlag = (req?: NextApiRequest) => {
  return (
    req?.cookies[algonomyPathFFCookieName] === 'true' ||
    FEATURE_ALGONOMY_ID_PATH
  );
};

export const FEATURE_FLAG_INSTORE_PROMOTION =
  process.env.NEXT_PUBLIC_ENABLE_INSTORE_PROMOTION === 'true';

export const FEATURE_FLAG_OVERRIDE_PDP_VALUE_PROPS =
  process.env.NEXT_PUBLIC_OVERRIDE_PDP_VALUE_PROPS === 'true';

export const FEATURE_FLAG_ALBY_CHATBOT =
  process.env.NEXT_PUBLIC_ALBY_CHATBOT_FF === 'true';

export const FEATURE_FLAG_PDP_PRODUCT_AVAILABILITY =
  process.env.NEXT_PUBLIC_FF_ENABLE_PDP_PRODUCT_AVAILABILITY === 'true';

export const FEATURE_FLAG_ALBY_CHATBOT_BUTTON =
  process.env.NEXT_PUBLIC_ALBY_CHATBOT_BUTTON_FF === 'true';

export const marketplacerFFCookieName = 'marketplacer-ff';
export const FEATURE_FLAG_MARKETPLACE =
  process.env.NEXT_PUBLIC_FF_ENABLE_MARKETPLACE === 'true';
export const getMarketplaceFeatureFlag = (req?: NextApiRequest) => {
  return (
    req?.cookies[marketplacerFFCookieName] === 'true' ||
    FEATURE_FLAG_MARKETPLACE
  );
};

export const FEATURE_FLAG_SHIPPING_ESTIMATES_CART_PAGE =
  process.env.NEXT_PUBLIC_FEATURE_FLAG_SHIPPING_ESTIMATES_CART_PAGE === 'true';

export const FEATURE_FLAG_SHIPPING_ESTIMATES =
  process.env.NEXT_PUBLIC_FEATURE_FLAG_SHIPPING_ESTIMATES === 'true';

export const FEATURE_FLAG_SHIPPING_ESTIMATES_SERVER =
  process.env.FEATURE_FLAG_SHIPPING_ESTIMATES_SERVER === 'true';

/**
 * PFS (Pick from Store): honours the variant-level `fulfillment_restriction`
 * metafield (ED-483), for pickup-only items (code 3) and items that ship only
 * from the WDC (code 4).
 * Off, the metafield is ignored everywhere and ship/pickup behave as before, so
 * Integrations can tag products before the storefront and checkout go live.
 */
export const FEATURE_FLAG_PFS = process.env.NEXT_PUBLIC_FF_PFS === 'true';

export const FEATURE_FLAG_ALGOLIA_COLLECTIONS =
  process.env.NEXT_PUBLIC_FF_ENABLE_ALGOLIA_COLLECTIONS === 'true';

export const FEATURE_FLAG_ALGOLIA_AUTOCOMPLETE_INITIAL_STATE =
  process.env.NEXT_PUBLIC_FF_ENABLE_ALGOLIA_AUTOCOMPLETE_INITIAL_STATE ===
  'true';

export const FEATURE_FLAG_RETURNS =
  process.env.NEXT_PUBLIC_FF_RETURNS === 'true';

export const FEATURE_FLAG_PDP_MIN_PURCHASE_QUANTITY =
  process.env.NEXT_PUBLIC_FF_MIN_QUANTITY === 'true';

export const FEATURE_FLAG_NEW_FOOTER =
  process.env.NEXT_PUBLIC_FF_ENABLE_NEW_FOOTER === 'true';

export const FEATURE_FLAG_PROMO_BAR_SERVER_SIDE =
  process.env.FF_ENABLE_PROMO_BAR === 'true';

export const FEATURE_FLAG_PROMO_BAR_SERVER_SIDE_ENABLED =
  process.env.NEXT_PUBLIC_FF_ENABLE_PROMO_BAR === 'true';

export const FEATURE_FLAG_MEMBER_PRICING =
  process.env.NEXT_PUBLIC_FF_ENABLE_MEMBER_PRICING === 'true';

export const FEATURE_FLAG_PDP_2026_1 =
  process.env.NEXT_PUBLIC_FF_PDP_2026_1 === 'true';

export const FEATURE_FLAG_ENABLE_PDP_SIZE_MERCHANDISING =
  process.env.NEXT_PUBLIC_FF_ENABLE_PDP_SIZE_MERCHANDISING === 'true';

export const FEATURE_FLAG_PDP_SIZE_MERCHANDISING =
  FEATURE_FLAG_PDP_2026_1 && FEATURE_FLAG_ENABLE_PDP_SIZE_MERCHANDISING;

export const FEATURE_FLAG_NEW_SPU_PROMOTION =
  process.env.NEXT_PUBLIC_FF_ENABLE_NEW_SPU_PROMOTION === 'true' ||
  FEATURE_FLAG_PDP_2026_1;

export const FEATURE_FLAG_DEALS_BANNER_SALE =
  process.env.NEXT_PUBLIC_FF_ENABLE_DEALS_BANNER_SALE === 'true';

export const FEATURE_FLAG_DEALS_BANNER =
  process.env.NEXT_PUBLIC_FF_ENABLE_DEALS_BANNER === 'true' ||
  FEATURE_FLAG_PDP_2026_1;

export const FEATURE_FLAG_PDP_IMAGE_GALLERY =
  process.env.NEXT_PUBLIC_FF_PDP_IMAGE_GALLERY === 'true' ||
  FEATURE_FLAG_PDP_2026_1;

export const FEATURE_FLAG_PDP_BUYZONE_V2 =
  process.env.NEXT_PUBLIC_FF_PDP_BUYZONE_V2 === 'true' ||
  FEATURE_FLAG_PDP_2026_1;

export const FEATURE_FLAG_COLOUR_PICKER_V2 =
  process.env.NEXT_PUBLIC_FF_COLOUR_PICKER_V2 === 'true' ||
  FEATURE_FLAG_PDP_2026_1;

export const FEATURE_FLAG_PDP_PRICE_CONTAINER =
  process.env.NEXT_PUBLIC_FF_PDP_PRICE_CONTAINER === 'true' ||
  FEATURE_FLAG_PDP_2026_1;

/**
 * Sticky Add to Cart bar (ED-157) — bottom-fixed bar (thumbnail, name, price, CTA) that
 * appears once the main PDP CTA scrolls out of view. Additive to the redesigned PDP's
 * right-column "follow down the side" behaviour (`usePdp2026ScrollInteraction`), which
 * stays enabled independently of this flag — the two run alongside each other.
 * Gated on its own env var only: PDP_2026_1 is already live on production, so
 * inheriting from it would ship the bar there unflagged.
 */
export const FEATURE_FLAG_STICKY_ATC_BAR =
  process.env.NEXT_PUBLIC_FF_STICKY_ATC_BAR === 'true';

/**
 * PDP "Why choose [brand]" section (ED-340). Gated on its own env var so
 * `why_choose` content can be published in Prismic before the section goes
 * live. It doesn't inherit from PDP_2026_1 (already live on production), but it
 * still requires it, since the section only exists in the 2026 PDP layout.
 */
export const FEATURE_FLAG_PDP_WHY_CHOOSE =
  process.env.NEXT_PUBLIC_FF_PDP_WHY_CHOOSE === 'true' &&
  FEATURE_FLAG_PDP_2026_1;

export const FEATURE_FLAG_PDP_REVIEWS_AND_ANSWERS =
  process.env.NEXT_PUBLIC_FF_ENABLE_PDP_REVIEWS_AND_ANSWERS === 'true';

export const FEATURE_FLAG_NEW_PRODUCT_STRIP =
  process.env.NEXT_PUBLIC_FF_NEW_PRODUCT_STRIP === 'true' ||
  FEATURE_FLAG_PDP_2026_1;

export const PARTNER_SITE_LINK_ENABLED =
  process.env.NEXT_PUBLIC_FF_PARTNER_SITE_LINK === 'true';

/* ────────────────────────────────────────────────────────────────────────────
 * Redesigned PLP — Phase 1 launch flags (ED-210)
 *
 * Every Phase 1 component below owns an individual launch flag so it can be
 * rolled out or killed on its own, plus FEATURE_FLAG_PLP_2026_1, the umbrella
 * flag that force-enables all of them at once. Mirrors the PDP 2026.1 pattern
 * above.
 * ──────────────────────────────────────────────────────────────────────────── */

/** Umbrella launch flag: overrides every individual PLP Phase 1 flag below. */
export const FEATURE_FLAG_PLP_2026_1 =
  process.env.NEXT_PUBLIC_FF_PLP_2026_1 === 'true';

/** PLP hero (Prismic `plp_hero`) — replaces the legacy PLP banner. */
export const FEATURE_FLAG_PLP_HERO =
  process.env.NEXT_PUBLIC_DISPLAY_PLP_HERO === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

/**
 * Hides the legacy Prismic-driven `PlpBanner` (image/video banner,
 * `plp_banner` field) — there's no "V2" banner component to swap to, this is
 * a pure show/hide toggle. Deliberately its own flag rather than reusing
 * FEATURE_FLAG_PLP_HERO — "attempt the new hero" and "still allow the old
 * banner to render" are separate business decisions (e.g. keep the legacy
 * banner temporarily on collections the new hero hasn't been authored for
 * yet), even though today both flip together via the umbrella.
 */
export const FEATURE_FLAG_HIDE_LEGACY_PLP_BANNER =
  process.env.NEXT_PUBLIC_FF_HIDE_LEGACY_PLP_BANNER === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

/**
 * Redesigned sort bar + filter system: FiltersProvider, the all-filters panel,
 * the V2 facet refinements and the full-width results layout (the legacy
 * sidebar and mobile facet button are hidden when this is on).
 */
export const FEATURE_FLAG_PLP_FILTERS_V2 =
  process.env.NEXT_PUBLIC_FF_PLP_FILTERS_V2 === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

/**
 * The filter pill row inside the redesigned filter bar. Requires
 * FEATURE_FLAG_PLP_FILTERS_V2 — the pills read FiltersProvider state, which
 * only mounts under that flag. Turning this off leaves the "View filters"
 * entry point (and therefore every facet) reachable.
 */
export const FEATURE_FLAG_PLP_FILTER_PILLS =
  process.env.NEXT_PUBLIC_FF_PLP_FILTER_PILLS === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

/**
 * Sticky filter bar (ED-531): pins the filter pill row and "All filters"
 * button under the site header once the shopper scrolls past it. Requires
 * FEATURE_FLAG_PLP_FILTERS_V2 — the row it pins only renders under that flag.
 */
export const FEATURE_FLAG_PLP_STICKY_FILTERS =
  (process.env.NEXT_PUBLIC_FF_PLP_STICKY_FILTERS === 'true' ||
    FEATURE_FLAG_PLP_2026_1) &&
  FEATURE_FLAG_PLP_FILTERS_V2;

/** Redesigned product card (HitV2) in the PLP results grid. */
export const FEATURE_FLAG_HIT_V2_ENABLED =
  process.env.NEXT_PUBLIC_FF_HIT_V2 === 'true' || FEATURE_FLAG_PLP_2026_1;

/** Redesigned PLP pagination (PlpPagination) in place of the InstantSearch widget. */
export const FEATURE_FLAG_NEW_PLP_PAGINATION =
  process.env.NEXT_PUBLIC_NEW_PLP_PAGINATION_FF === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

export const FEATURE_FLAG_PTT_V2 = process.env.NEXT_PUBLIC_FF_PTT_V2 === 'true';

/**
 * Independently hides the legacy PTTOne/PTTTwo/PTTThree/PTTAsImage tiles.
 * Deliberately its own flag rather than the inverse of FEATURE_FLAG_PTT_V2
 * (Jason's call, ED-210 QA round 2) — "show the new takeover PTT" and "hide
 * the legacy PTT" are separable decisions (e.g. hiding both during a UAT
 * window where V2 isn't ready to show yet but legacy also shouldn't be what
 * testers focus on). Standalone like FEATURE_FLAG_PTT_V2 — neither ORs into
 * the PLP 2026.1 umbrella.
 */
export const FEATURE_FLAG_HIDE_LEGACY_PTT =
  process.env.NEXT_PUBLIC_FF_HIDE_LEGACY_PTT === 'true';

/** Quick Add popover on the PLP product card (legacy `Hit` and `HitV2` alike). */
export const FEATURE_FLAG_QUICK_ADD =
  process.env.NEXT_PUBLIC_FF_QUICK_ADD === 'true' || FEATURE_FLAG_PLP_2026_1;

/**
 * SEO content accordion (ED-195). The flag is a swap, not a toggle: off renders
 * the legacy SeoContentComponent, on renders SeoContentAccordion — SEO copy is
 * present either way.
 *
 * Deliberately not PLP-scoped: this gates all three render sites (the PLP,
 * CategoryPageSliceHandler and LandingPageSliceHandler), so
 * FEATURE_FLAG_PLP_2026_1 switches the accordion on for category and landing
 * pages as well, not just the PLP.
 *
 * Declared here ahead of its consumers: ED-195 owns SeoContentAccordion and the
 * three render sites, and lands after this. Until then this flag has no effect
 * — that is expected, not dead code to remove. ED-195 declares the same name
 * without the umbrella clause, so merging it conflicts on this one declaration;
 * keep this version and drop theirs.
 */
export const FEATURE_FLAG_SEO_ACCORDION =
  process.env.NEXT_PUBLIC_FF_SEO_ACCORDION === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

/** PLP deals banner / product deals strip (server-side Prismic fetch). */
export const PLP_PRODUCT_DEALS_STRIP =
  process.env.PLP_PRODUCT_DEALS_STRIP === 'true' || FEATURE_FLAG_PLP_2026_1;

/** All Deals PLP deals grid, ED-197 (server-side Prismic fetch). */
export const PLP_DEALS_GRID = process.env.PLP_DEALS_GRID === 'true';

export const FEATURE_FLAG_PLP_SORT_BAR_V2 =
  process.env.NEXT_PUBLIC_FF_PLP_SORT_BAR_V2 === 'true';

export const FEATURE_FLAG_PLP_SORT_SHEET_SAFE_AREA =
  process.env.NEXT_PUBLIC_FF_PLP_SORT_SHEET_SAFE_AREA === 'true';

/**
 * Redesigned product line carousel (`_components/ProductLineCarousel`). A swap,
 * not a toggle: off renders the legacy `components/algolia/ProductLineCarousel`,
 * so the carousel is present either way.
 */
export const PRODUCT_LINE_CAROUSEL_V2 =
  process.env.NEXT_PUBLIC_PRODUCT_LINE_CAROUSEL_V2 === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

/**
 * Hides the legacy Prismic-driven "Shop by category" carousel
 * (`CategoryCarousels`, `collectionData.categoryCarousels`). No replacement
 * component exists — the redesigned PLP simply omits it — this is a pure
 * show/hide toggle, not a component swap.
 */
export const FEATURE_FLAG_HIDE_LEGACY_PLP_CATEGORY_CAROUSEL =
  process.env.NEXT_PUBLIC_FF_HIDE_LEGACY_PLP_CATEGORY_CAROUSEL === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

/**
 * Redesigned breadcrumbs (ED-454). Tracked on its own ticket, but umbrella-wired
 * like the rest of Phase 1: breadcrumbs are part of the PLP redesign, and the
 * umbrella should not leave legacy breadcrumbs sitting above a redesigned hero,
 * filter bar and results grid.
 *
 * Both branches emit BreadcrumbList JSON-LD, but from different sources — the
 * legacy component derives itemListElements from Algolia refinement state, the
 * V2 component from the `breadcrumbCategories` server prop. Flipping the
 * umbrella therefore changes structured data on indexed category pages; watch
 * Search Console after a rollout. See docs/PLP_PHASE_1_LAUNCH_FLAGS.md.
 */
export const FEATURE_FLAG_BREADCRUMBS_V2 =
  process.env.NEXT_PUBLIC_FF_BREADCRUMBS_V2 === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

/**
 * Full-width PLP layout (ED-210 UAT feedback): the category PLP and `/search`
 * routes escape the shared `Container`'s fixed 1264/1360px width via its
 * `fullWidth` prop, so the page and product grid scale with the viewport
 * instead of sitting in a centered box on wide screens.
 *
 * Also switches `SearchResults/Header`'s `.headerRecommendations` max-width
 * from the old Container-anchored calc to a viewport-relative one so it keeps
 * pace with the now-fluid container, on both routes.
 */
export const FEATURE_FLAG_PLP_FULL_WIDTH =
  process.env.NEXT_PUBLIC_FF_PLP_FULL_WIDTH === 'true' ||
  FEATURE_FLAG_PLP_2026_1;

/**
 * Main Hero (Prismic `main_hero`) — CIP/CLP top-of-page banner (ED-217).
 * Standalone flag: not part of the FEATURE_FLAG_PLP_2026_1 umbrella, since
 * that initiative is PLP-scoped and this ships on category intro / landing
 * pages, not the PLP.
 */
export const FEATURE_FLAG_MAIN_HERO =
  process.env.NEXT_PUBLIC_FF_MAIN_HERO === 'true';

/**
 * Learn Strip (Prismic `learn_strip`) — CIP/CLP expert advice carousel
 * (ED-231). Standalone for the same reason as FEATURE_FLAG_MAIN_HERO: it
 * ships on category intro / landing pages rather than the PLP, so the
 * PLP-scoped umbrella flag must not carry it.
 */
export const FEATURE_FLAG_LEARN_STRIP =
  process.env.NEXT_PUBLIC_FF_LEARN_STRIP === 'true';

/**
 * Promo Tiles (Prismic `promo_tiles`) — CIP/CLP 1-4 card promo grid (ED-225).
 * Standalone for the same reason as FEATURE_FLAG_MAIN_HERO: it ships on
 * category intro / landing pages rather than the PLP, so the PLP-scoped
 * umbrella flag must not carry it.
 */
export const FEATURE_FLAG_PROMO_TILES =
  process.env.NEXT_PUBLIC_FF_PROMO_TILES === 'true';

/**
 * Brand Tiles (Prismic `brand_tiles`) — CIP/CLP "shop by brand" carousel of
 * logo cards (ED-227). Standalone for the same reason as
 * FEATURE_FLAG_MAIN_HERO: it ships on category intro / landing pages rather
 * than the PLP, so the PLP-scoped umbrella flag must not carry it.
 */
export const FEATURE_FLAG_BRAND_TILES =
  process.env.NEXT_PUBLIC_FF_BRAND_TILES === 'true';

/**
 * Activity Navigation Grid (Prismic `activity_navigation_grid`) — CIP/CLP
 * curated 4-8 card image navigation carousel (ED-219). Standalone flag, same
 * reasoning as FEATURE_FLAG_MAIN_HERO: this ships on category intro / landing
 * pages, not the PLP, so it isn't part of the FEATURE_FLAG_PLP_2026_1 umbrella.
 */
export const FEATURE_FLAG_ACTIVITY_NAVIGATION_GRID =
  process.env.NEXT_PUBLIC_FF_ACTIVITY_NAVIGATION_GRID === 'true';

/**
 * PLP cross-linking band (ED-211). Public because both the server-side fetch and
 * the client-side grid injection read it, and they must agree.
 *
 * Deliberately standalone — not umbrella-wired to FEATURE_FLAG_PLP_2026_1. ED-211
 * is not part of the Phase 1 scope documented in docs/PLP_PHASE_1_LAUNCH_FLAGS.md,
 * so flipping the umbrella must not ship the cross-linking band with it.
 */
export const FEATURE_FLAG_PLP_CROSS_LINKING =
  process.env.NEXT_PUBLIC_FF_PLP_CROSS_LINKING === 'true';

/**
 * Image Hotspot (Prismic `image_hotspot`) — CIP/CLP "Shop the Gear / Shop the
 * Look" tabbed lifestyle image banner (ED-345). Standalone flag, same
 * reasoning as FEATURE_FLAG_MAIN_HERO: this ships on category intro / landing
 * pages, not the PLP, so it isn't part of the FEATURE_FLAG_PLP_2026_1 umbrella.
 */
export const FEATURE_FLAG_IMAGE_HOTSPOT =
  process.env.NEXT_PUBLIC_FF_IMAGE_HOTSPOT === 'true';

/**
 * ED-502 hidden size runs: the per-style repair of the F26 kids size curves in
 * `adapters/bigcommerce/transforms/utils/hiddenSizeRuns.ts`. Off, the PDP
 * renders every size BigCommerce returns, in BigCommerce's order, which is
 * today's production behaviour.
 *
 * Server-only, no `NEXT_PUBLIC_` prefix: the sole consumer is the BigCommerce
 * product transform, which runs in the PDP's `getServerSideProps`. The PDP is
 * not statically cached, so setting this to anything but `true` and redeploying
 * kills the repair on the next request without reverting the code.
 *
 * Temporary, and paired with the file it gates. Delete both when merch re-sets
 * these styles.
 */
export const FEATURE_FLAG_HIDDEN_SIZE_RUNS =
  process.env.FF_HIDDEN_SIZE_RUNS === 'true';
